<div class="grid-x grid-margin-x teaser-wrapper">
  <h1 class="cell text-center">{{ 'heizcheck.einstieg.headline' | translate: welcomePlaceholder }}</h1>
  <div class="cell small-12 medium-offset-2 medium-3">
    <app-advisor-image path="/hec/hec-einstieg.svg"></app-advisor-image>
  </div>
  <div class="cell small-12 medium-5">
    <div class="callout" [innerHTML]="'heizcheck.einstieg.teaser' | translate"></div>
  </div>
</div>

<div [@routeAnimations]="prepareRoute()" class="step-content-wrapper" #stepWrapper [style.min-height]="componentHeight + 'px'">
  <router-outlet></router-outlet>
</div>
